import { useNavigate } from 'react-router-dom'
import type { Lender } from '@/types'
import { ApisSubTab } from './ApisSubTab'
import { BatchesSubTab } from './BatchesSubTab'
import { PlaygroundSubTab } from './PlaygroundSubTab'
import { WorkflowsSubTab } from '../flow/WorkflowsSubTab'
import { EndpointsSubTab } from '../flow/EndpointsSubTab'

export const SUBS = [
  ['apis', '3.1 Lender APIs'],
  ['batches', '3.2 API batches'],
  ['playground', '3.3 Playground'],
  ['workflows', '3.4 Workflows'],
  ['endpoints', '3.5 Service endpoints'],
] as const
export type SubId = (typeof SUBS)[number][0]

/** Tab 3 · Lender API workflow (F2-1): five sub-tabs in the address; 3.1–3.3 built in LH-F2, 3.4–3.5 in LH-F3. */
export function ApiTab({ lender, sub = 'apis' }: { lender: Lender; sub?: string }) {
  const navigate = useNavigate()
  const current: SubId = (SUBS.find((s) => s[0] === sub)?.[0] ?? 'apis') as SubId
  return (
    <>
      <div className="mb-3 inline-flex max-w-full gap-0.5 overflow-x-auto rounded-md bg-slate-100 p-0.5 dark:bg-slate-800" role="tablist" aria-label="Lender API workflow">
        {SUBS.map(([id, label]) => (
          <button key={id} type="button" role="tab" aria-selected={id === current} onClick={() => navigate(`/lenders/${lender.slug}/api/${id}`)} className={`whitespace-nowrap rounded px-3 py-1.5 text-xs font-medium ${id === current ? 'bg-white text-default shadow-card dark:bg-surface-dark' : 'text-muted hover:text-default'}`}>
            {label}
          </button>
        ))}
      </div>
      {current === 'apis' && <ApisSubTab lender={lender} />}
      {current === 'batches' && <BatchesSubTab lender={lender} />}
      {current === 'playground' && <PlaygroundSubTab lender={lender} />}
      {current === 'workflows' && <WorkflowsSubTab lender={lender} />}
      {current === 'endpoints' && <EndpointsSubTab lender={lender} />}
    </>
  )
}
